<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title><span class="ml-2">RESTABLECER CLAVE</span></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content :fullscreen="true">
      <div class="fondo">
        <div class="ion-padding">
          <ion-label class="ion-text-center">
            <p>INGRESA TU RUT Y CORREO REGISTRADO PREVIAMENTE EN NUESTROS SISTEMAS.</p>
          </ion-label>
          <h2 class="ion-text-center">INVERLUZ S.A.</h2>
        </div>
        <div class="ion-padding-horizontal ion-margin-horizontal ion-justify-content-center">
          <ion-row class="ion-text-center ion-justify-content-center">
            <ion-col size="8">
              <ion-input class="input-login" maxlength="12" autofocus="true" type="text" placeholder="RUT" v-bind:value="rut" @ionInput="rut = formateaRut($event.target.value)"></ion-input>
                <ion-input class="input-login ion-margin-top" maxlength="50" type="mail" v-model="correo" placeholder="CORREO"></ion-input>
            </ion-col>
          </ion-row>
          
        </div>
        <div class="ion-padding ion-margin-top">
          <ion-label class="ion-text-center">
            <p>SE ENVIARÁ UN CORREO A TU CUENTA REGISTRADA CON UNA NUEVA CLAVE DE ACCESO.</p>
          </ion-label>
        </div>
        <div class="ion-padding-horizontal ion-margin-horizontal">
          <ion-row class="ion-text-center ion-justify-content-center">
            <ion-col size="8">
              <ion-button class="btn-ingresar" color="dark" shape="round" expand="block" @click="restablecerClave();">
                <ion-icon name="log-in-outline"></ion-icon>
                <ion-label style="margin-left:10px;">ACEPTAR</ion-label>
              </ion-button>

            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-content>

</template>

<script>
import { IonHeader, IonToolbar, IonTitle, IonContent, IonLabel, IonButton, modalController, toastController, 
          loadingController, IonIcon, IonCol, IonRow, IonInput } from '@ionic/vue';
import { defineComponent   } from 'vue';
import { addIcons          } from 'ionicons';
import { logInOutline, arrowBackOutline } from 'ionicons/icons';
import axios      from 'axios';
import rutaBase   from '@/plugins/variables';

export default defineComponent({
  name: 'OlvidasteClave',
  props: {
    modal       : Object
  },
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonLabel, IonButton, IonIcon, IonCol, IonRow, IonInput
  },
  data() {
    return { 
      cargando      : false,
      rut           : '',
      correo        : '',
    }
  },
  created() {
    addIcons({
      'log-in-outline'      : logInOutline,
      'arrow-back-outline'  : arrowBackOutline
    });
  },
  methods:{
    async restablecerClave(){
      if(this.rut && this.correo) {  
        this.muestraCargando();
        const dato  = new URLSearchParams();
        const rutLimpio       = this.rut.replace(/[.|-]/g, '').slice(0, -1);
        dato.append('rut'     , rutLimpio.toString());
        dato.append('correo'  , this.correo.toString());
        axios.post(rutaBase+'/login/reestablecerClave', dato).then( resp => {
          if(resp.data.key == 1){
            this.muestraToast('CLAVE ENVIADA A SU CORREO.');
            this.rut    = '';
            this.correo = '';
            this.cerrarModal();
          }
          else{
            this.muestraToast(resp.data.resp.msj);
          }
        }).catch((error) =>{
          console.log(error)
          this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
        });
      }
      else {
        this.muestraToast('DATOS INCORRECTOS');
      }
    }, 

    async muestraCargando(){
      const alertCargando = await loadingController
        .create({
          cssClass: 'my-custom-class',
          message: 'CARGANDO...',
          duration: 2500,
        });
      await alertCargando.present();
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 4000,
          cssClass: 'text-center'
        })
      return toast.present();
    },

    formateaRut(rut){
      const newRut = rut.replace(/\./g,'').replace(/[^k|K|\d]/g, '').replace(/-/g, '').trim().toUpperCase();
      const lastDigit = newRut.substr(-1, 1);
      const rutDigit = newRut.substr(0, newRut.length-1)
      let format = '';
      let i = 0;
      let j = 1;
      for (i = rutDigit.length - 1; i >= 0; i--) {
        const e = rutDigit.charAt(i);
        format = e.concat(format);
        if (j % 3 == 0 && j <= rutDigit.length - 1) {
          format = '.'.concat(format);
        }
        j++;
      }
      let formateado = "";
      if(format.length > 0){
        formateado = format.concat('-').concat(lastDigit);
      }
      else{
        formateado = lastDigit;
      }
      return formateado;
    },

    async cerrarModal(dato=false){
      modalController.dismiss({recargar: dato});
    }
  }
});
</script>

<style scoped>
.fondo{
  /* background-color: #d7d8da !important; */
  height: 100% !important;
  padding-top: 15%;
}

.btn-ingresar {
  height: 50px!important;
}

.input-code{
  background-color: white !important;
  border-radius: 50rem!important;
  font-size: 30px;
  margin: auto;
  padding-left: 0px!important;
  border: 1px solid black!important;
}

</style>